import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SectionCardSaudeContainerService } from './section-card-saude-container.service';
import { Observable } from 'rxjs';
import { SectionCardSaudeData } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-section-card-saude-container',
  template: `
    <fcp-section-card-saude
      [sectionCardSaude]="data | async"
      (clicked)="clicked.emit($event)"
    ></fcp-section-card-saude>
  `
})
export class SectionCardSaudeContainerComponent implements OnInit {
  @Input() public id: string;
  @Output() public clicked: EventEmitter<any> = new EventEmitter();
  public data: Observable<SectionCardSaudeData>;
  constructor(
    private sectionCardSaudeContainerService: SectionCardSaudeContainerService
  ) {}

  ngOnInit() {
    this.data = this.sectionCardSaudeContainerService.getDestaquePlanosSaude(
      this.id
    );
  }
}
